<template>
  <b-modal
    id="filter-fields-modal"
    ref="modal"
    title="Dostępne pola do filtrowania"
    size="lg"
    @hidden="onClose">
    <div v-if="loading" class="text-center p-4">
      <b-spinner />
    </div>
    <div v-else>
      <b-form-input
        v-model="searchQuery"
        placeholder="Szukaj pola..."
        class="mb-3" />
      
      <div class="filter-fields-list" style="max-height: 400px; overflow-y: auto;">
        <b-list-group>
          <b-list-group-item
            v-for="field in filteredFields"
            :key="field.field"
            class="d-flex justify-content-between align-items-center"
            @click="selectField(field)"
            style="cursor: pointer;">
            <div>
              <strong>{{ field.label }}</strong>
              <small class="d-block text-muted">{{ field.field }}</small>
            </div>
            <feather-icon icon="ChevronRightIcon" />
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>

    <template #modal-footer>
      <b-button variant="secondary" @click="onClose">Zamknij</b-button>
    </template>
  </b-modal>
</template>

<script>
import { getFilterFields } from '@/http/navigation';

export default {
  name: 'FilterFieldsModal',
  data() {
    return {
      fields: [],
      loading: false,
      searchQuery: '',
    };
  },
  computed: {
    filteredFields() {
      if (!this.searchQuery) {
        return this.fields;
      }
      
      const query = this.searchQuery.toLowerCase();
      return this.fields.filter(
        (field) =>
          field.label.toLowerCase().includes(query) ||
          field.field.toLowerCase().includes(query)
      );
    },
  },
  mounted() {
    this.fetchFilterFields();
  },
  methods: {
    async fetchFilterFields() {
      this.loading = true;
      try {
        const { data } = await getFilterFields();
        this.fields = data.fields || [];
      } catch (error) {
        console.error('Error fetching filter fields:', error);
        this.$bvToast.toast('Nie udało się pobrać pól filtrowania', {
          title: 'Błąd',
          variant: 'danger',
          solid: true,
        });
      } finally {
        this.loading = false;
      }
    },
    selectField(field) {
      this.$emit('field-selected', field);
      this.$refs.modal.hide();
    },
    onClose() {
      this.searchQuery = '';
      this.$emit('close');
    },
    show() {
      this.$refs.modal.show();
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-fields-list {
  .list-group-item {
    transition: background-color 0.2s;
    
    &:hover {
      background-color: #f8f9fa;
    }
  }
}
</style>

